import React from "react"
import { Nav } from "react-bootstrap"

const ContactNav = () => {
  return (
    <Nav className="contact-div">
      <div className="nav-contact">
        <button
          className="contact-us-link pt-0"
          onClick={() => (window.location.href = "/contact")}
        >
          <span className="c-us">Contact Us</span>
        </button>
      </div>
    </Nav>
  )
}

export default ContactNav
